/**
 * Golf bag icon — switches between light and dark image variants
 * based on Tailwind's dark mode class on <html>.
 *
 * Both apps serve the images from their own /public/ directory:
 *   /Golfbag1.png      (light mode)
 *   /Golfbag_dark.png  (dark mode)
 */
export function GolfBagIcon({ className }: { className?: string }) {
  const base = className?.trim() ?? '';
  const lightCls = base ? `${base} dark:hidden` : 'dark:hidden';
  const darkCls = base ? `${base} hidden dark:block` : 'hidden dark:block';

  return (
    <>
      <img src="/Golfbag1.png" alt="" aria-hidden className={lightCls} />
      <img src="/Golfbag_dark.png" alt="" aria-hidden className={darkCls} />
    </>
  );
}
